var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircledScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0026 3.01579C9.01769 3.01579 8.04242 3.20978 7.13248 3.58669C6.22254 3.9636 5.39574 4.51605 4.6993 5.21249C4.00286 5.90893 3.45042 6.73572 3.07351 7.64566C2.6966 8.5556 2.5026 9.53087 2.5026 10.5158C2.5026 11.5007 2.6966 12.476 3.07351 13.3859C3.45042 14.2959 4.00286 15.1226 4.6993 15.8191C5.39574 16.5155 6.22254 17.068 7.13248 17.4449C8.04242 17.8218 9.01769 18.0158 10.0026 18.0158C11.9917 18.0158 13.8994 17.2256 15.3059 15.8191C16.7124 14.4126 17.5026 12.5049 17.5026 10.5158C17.5026 8.52666 16.7124 6.61901 15.3059 5.21249C13.8994 3.80596 11.9917 3.01579 10.0026 3.01579ZM0.835938 10.5158C0.835938 5.45329 4.9401 1.34912 10.0026 1.34912C15.0651 1.34912 19.1693 5.45329 19.1693 10.5158C19.1693 15.5783 15.0651 19.6825 10.0026 19.6825C4.9401 19.6825 0.835938 15.5783 0.835938 10.5158Z",
    fill: "#8B6CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41074 12.9818C4.0853 13.3072 4.0853 13.8348 4.41074 14.1603C4.73618 14.4857 5.26382 14.4857 5.58925 14.1603L8.3898 11.3597L9.47289 12.2442C9.81321 12.5222 10.3109 12.4881 10.6102 12.1664L13.3357 9.23642L14.392 10.3632C14.7068 10.699 15.2342 10.716 15.5699 10.4012C15.9057 10.0864 15.9227 9.55905 15.6079 9.22329L13.9413 7.44551C13.7834 7.27706 13.5626 7.18168 13.3317 7.18213C13.1008 7.18258 12.8804 7.27881 12.7232 7.44788L9.92198 10.4592L8.86044 9.59224C8.52907 9.32162 8.0466 9.3459 7.74407 9.64843L4.41074 12.9818Z",
    fill: "#8B6CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledScore);
export default __webpack_public_path__ + "static/media/circled-score.ad0c46ae7611aa95b15ae1c96b75e448.svg";
export { ForwardRef as ReactComponent };